import { z } from 'zod';

const baseNewApprovalSetupSchema = z.object({
  application: z.number().nullable(),
  approvalAdministrator: z.string(),
  approvalEmailTemplate: z.number().nullable(),
  assignedUser: z.number().nullable(),
  notes: z.string(),
  positionTitle: z.string()
});

export const createNewApprovalSetupSchema = (
  positionTitleRequired: boolean
): typeof baseNewApprovalSetupSchema =>
  baseNewApprovalSetupSchema.superRefine(({ positionTitle }, context) => {
    if (positionTitleRequired && !positionTitle) {
      context.addIssue({
        code: 'custom',
        message: 'Position title is required to create an approval form.',
        path: ['positionTitle']
      });
    }
  });

export type NewApprovalSetupValues = z.infer<typeof baseNewApprovalSetupSchema>;

export interface NewApprovalSetupAttributes {
  application_id: number | null;
  assigned_user_id: number | null;
  email_template_id: number | null;
  note: string;
  position_title: string;
  to_email: string;
}

export const getNewApprovalSetupDefaults = (
  approvalAdministrator = ''
): NewApprovalSetupValues => ({
  application: null,
  approvalAdministrator,
  approvalEmailTemplate: null,
  assignedUser: null,
  notes: '',
  positionTitle: ''
});

export const buildNewApprovalSetupAttributes = (
  values: NewApprovalSetupValues
): NewApprovalSetupAttributes => ({
  application_id: values.application,
  assigned_user_id: values.assignedUser,
  email_template_id: values.approvalEmailTemplate,
  note: values.notes,
  position_title: values.positionTitle,
  to_email: values.approvalAdministrator
});

export const hasNewApprovalUnsavedChanges = (
  dynamicFieldsDirty: boolean,
  setupFieldsDirty: boolean
): boolean => [dynamicFieldsDirty, setupFieldsDirty].some(Boolean);
